import { Material } from "@/models/material.model";
import { Pagination, QueryParams } from "@/models/query-params.model";
import api from "@/services/api-config/rxjs-config";
import { Observable } from "rxjs";

export class MaterialsRest {
  baseURL = "/graphs";
  accessFile = "/access-file";

  getMaterialById(
    learningObjectivesId: string,
    materialId: string
  ): Observable<any> {
    const url: string = `/learning-objectives/${learningObjectivesId}/materials/${materialId}`;
    return api.get(url, {}, this.baseURL);
  }

  postMaterial(objectiveId: string, data: any): Observable<any> {
    const url: string = `/learning-objectives/${objectiveId}/materials`;
    return api.post(url, data, {}, this.baseURL);
  }

  postMaterialTraditional(
    courseId: string,
    objectiveId: string,
    data: any
  ): Observable<any> {
    const url: string = `/third-party/courses/${courseId}/trail/${objectiveId}/material`;
    return api.post(url, data, {}, this.baseURL);
  }

  updateMaterial(
    objectiveId: string,
    materialId: string,
    data: any
  ): Observable<any> {
    const url: string = `/learning-objectives/${objectiveId}/materials/${materialId}`;
    return api.patch(url, data, {}, this.baseURL);
  }

  deleteMaterial(objectiveId: string, materialId: string): Observable<any> {
    const url: string = `/learning-objectives/${objectiveId}/materials/${materialId}`;
    return api.delete(url, this.baseURL);
  }

  getLearningObjectiveByChapter(chapterId: string): Observable<any> {
    const url: string = `/chapters/${chapterId}/learning-objectives`;
    return api.get(url, {}, this.baseURL);
  }

  materialEvent(
    courseId: string,
    userId: string,
    data: any,
    params?: Partial<QueryParams>
  ): Observable<any> {
    const url: string = `/course-state/${courseId}/${userId}/add-material-event`;
    return api.post(url, data, params, this.baseURL);
  }

  getMaterials(
    courseId: string,
    userId: string,
    routeName: string,
    learningObjectiveId?: string,
    params?: Partial<QueryParams>
  ): Observable<any> {
    learningObjectiveId = learningObjectiveId ? `/${learningObjectiveId}` : "";
    const url: string = `/course-state/${courseId}/${userId}/${routeName}${learningObjectiveId}`;
    return api.get(url, params, this.baseURL);
  }

  getAllMaterials(
    courseId: string,
    userId: string,
    routeName: string,
    params?: Partial<QueryParams>
  ): Observable<any> {
    const url:string = `/learning-flows/${courseId}/${userId}/${routeName}`
    return api.get(url, params, this.baseURL);
  }
  getObjectsByLearningObjective(
    objectiveId: string,
    params: QueryParams
  ): Observable<Pagination<Material>> {
    const url: string = `/learning-objectives/${objectiveId}/materials`;
    return api.get(url, params, this.baseURL);
  }

  orderMaterials(lessonId: string, data: Material[]): Observable<void> {
    const url: string = `/lesson-plans/${lessonId}/materials`;
    return api.put(url, data, {}, this.baseURL);
  }

  static getAllInteractiveMaterials(
    params?: Partial<QueryParams>
  ): Observable<Pagination<any>> {
    const url: string = ``;
    return api.get(url, params, "/h5p");
  }
}
